luckyBetToggleButton = {};

luckyBetToggleButton.create = function () {
  var button = new PIXI.Container();

  button.luckyBetMessage = undefined;
  button._isPromotion = false;

  InputHelpers.addGenerics(button);
  button._flags.showLuckyBetActive = false;

  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button._flags.platformEnabled = false;
  button._flags.platformVisible = false;

  button.canShow = function () {
    const hideInCoins =
      layoutController.getCurrentLayout() === "landscape_mobile" && CoinsView.HideGoldenBet ? false : true;
    return !gameController.inFreeSpins && this._flags.platformVisible && hideInCoins;
  };

  button.canEnable = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    const goldenbetStakes = this.gameConfig.data.slotConfig.gameModes.LUCKYBET_BUY.coinSizes;
    const baseStake = resourceManager.getController("stakeController").BaseStake;
    const isCurrentBetAllowed = goldenbetStakes.includes(baseStake);
    button.canPlaceBet = isCurrentBetAllowed;
    const hideInCoins =
      layoutController.getCurrentLayout() === "landscape_mobile" && CoinsView.HideGoldenBet ? false : true;

    var allow =
      hideInCoins &&
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !this._isPromotion &&
      this._flags.platformEnabled &&
      !gameController.inFreeSpins &&
      goldenbetStakes.length !== 0 &&
      isCurrentBetAllowed;

    this.button.buttonDisabled.alpha = allow ? 1 : 0.5;

    this._luckyBetOff = resourceManager.get("postReels:freespinsLuckyBet:luckyBetOff");
    this._luckyBetOff.alpha = allow ? 1 : 0.5;
    this._luckyBetOn = resourceManager.get("postReels:freespinsLuckyBet:luckyBetOn");
    this._luckyBetOn.alpha = allow ? 1 : 0.5;

    return allow;
  };

  button.getCanPlaceBet = function () {
    return button.canPlaceBet;
  };

  button.onConfig = function (config) {
    this.gameConfig = config;
    this._flags.platformEnabled = config.data.uiElements.btnUpstake.enabled;
    this._flags.platformVisible = config.data.uiElements.btnUpstake.visible;
  };

  button.isAllowed = function () {
    return this._flags.platformEnabled;
  };

  button.setupResources = function () {
    let self = this;
    messageBus.subscribe("spinner:GameConfigEvent", function () {
      self.onLayoutComplete();
    });

    messageBus.subscribe("spinner:GameConfigEvent", button.onConfig.bind(button));
    messageBus.subscribe("common:PromotionStarted", button.promotionStarted.bind(button));
    messageBus.subscribe("common:PromotionEnded", button.promotionEnded.bind(button));
    messageBus.subscribe("spinner:SpinEvent", button.onSpin.bind(button));
  };

  button.onLayoutComplete = function () {
    button.luckyBetMessage = resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton:luckyBetMessage");
    button.animParent = resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton");

    button.luckyBetMessage.alpha = 0.0;

    button.innerFadeTimer = undefined;
    button.outerFadeTimer = undefined;
  };

  button.showButton = function () {
    if (this.canShow()) {
      if (!button._flags.showLuckyBetActive) {
        this.button.buttonDisabled.visible = true;
        this.button.buttonEnabled.visible = false;
      } else {
        this.button.buttonDisabled.visible = false;
        this.button.buttonEnabled.visible = true;
      }

      this.button.visible = true;
    } else {
      this.button.visible = false;

      this.button.buttonDisabled.visible = false;
      this.button.buttonEnabled.visible = false;
    }
  };

  button.enterFreeSpins = function () {
    // on entering buy a bonus we must disable lucky bet
    if (gameController.inBuyABonus) {
      button._flags.showLuckyBetActive = false;
    }

    if (button.innerFadeTimer !== undefined) {
      timerManager.stop(button.innerFadeTimer);
    }

    if (button.outerFadeTimer !== undefined) {
      timerManager.stop(button.outerFadeTimer);
    }
    resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton:button").visible = false;
  };

  button.exitFreeSpins = function () {
    resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton").visible = true;
    // on entering buy a bonus we must disable lucky bet
    if (gameData.encoreEnabled) {
      button._flags.showLuckyBetActive = true;
      resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton:button").visible = true;
    }
  };

  button.enterBuyABonus = function () {
    // on entering buy a bonus we must disable lucky bet
    CloverRespins.respinData = undefined;
    button._flags.showLuckyBetActive = false;
    button.cancelLuckyBet();
  };

  button.cancelLuckyBet = function () {
    if (button.luckyBetMessage !== undefined) {
      button.luckyBetMessage.alpha = 0.0;

      if (button.innerFadeTimer !== undefined) {
        timerManager.stop(button.innerFadeTimer);
      }

      if (button.outerFadeTimer !== undefined) {
        timerManager.stop(button.outerFadeTimer);
      }

      if (gameData.encoreEnabled) {
        gameController.stopCyclingWins();
        gameController.slotMachine.clearDimSymbolIds();
        gameData.winningsMeter.set(0);
      }
      gameData.encoreEnabled = false;
      const stake = button.handleStakeChange(true);

      gameController.currentNonBABStake = stake;
    }
  };

  button.handleStakeChange = function (broadcast) {
    const stakeController = resourceManager.getController("stakeController");
    let bpl = stakeController.BaseStake / this.gameConfig.data.slotConfig.defaultNumLines;
    let luckyBetEnabled = gameData.encoreEnabled;
    const stakeMultiplier = luckyBetEnabled ? 1.5 : 1;
    stakeController.setStakeMultiplier(stakeMultiplier);
    const stake = stakeController.BaseStake * stakeMultiplier;
    game.changeStake(stake, bpl);

    if (broadcast) {
      stakeController.broadcastCurrentStake();
    }

    return stake;
  };

  button.setRecovery = function () {
    // only called when we are recovering the game to set the game as lucky bet active
    button._flags.showLuckyBetActive = true;
    gameData.encoreEnabled = true;
    button.handleStakeChange(true);
    button.toggleOn(true);
  };

  button.promotionStarted = function () {
    this._isPromotion = true;
  };

  button.promotionEnded = function () {
    this._isPromotion = false;
  };

  button.onSpin = function () {
    button.luckyBetMessage.visible = false;
  };

  button.toggleOn = function (fromRecovery = false) {
    button._flags.showLuckyBetActive = true;

    if (!fromRecovery) {
      button.luckyBetMessage.visible = true;
      button.luckyBetMessage.alpha = 1.0;
      button.outerFadeTimer = timerManager.addTimer(2000, undefined, function () {
        button.innerFadeTimer = timerManager.addTimer(
          750,
          function (progress) {
            button.luckyBetMessage.alpha = 1 - progress;
          },
          function () {
            button.luckyBetMessage.alpha = 0.0;
          }
        );
      });

      soundManager.play("activateGoldenBet");
    }

    gameData.encoreEnabled = true;
    button.handleStakeChange(true);
  };

  button.onPressedCallback = function () {
    button._flags.showLuckyBetActive = !button._flags.showLuckyBetActive;

    if (button._flags.showLuckyBetActive) {
      if (button.luckyBetMessage !== undefined) {
        button.toggleOn();
      }
    } else {
      button.cancelLuckyBet();
      if (button.luckyBetMessage !== undefined) {
        soundManager.play("cancelGoldenBet");
      }
    }
  };

  return button;
};

luckyBetToggleButton.hideMessage = () => {
  const msg = resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton:luckyBetMessage");
  msg.visible = false;
};

luckyBetToggleButton.initialise = function (json, object) {
  object.setupResources();
};

luckyBetToggleButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "luckyBetToggleButton",
  luckyBetToggleButton.create,
  luckyBetToggleButton.initialise,
  luckyBetToggleButton.getFilesRequired
);
